import { render } from "./BasicCard.vue?vue&type=template&id=921fb5b2"
const script = {}

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__